import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=4136cf59&"
import script from "./AppMenu.vue?vue&type=script&lang=ts&"
export * from "./AppMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports